export class RequestPickup {
    DentistId: any; 
    DentistCompanyId:any;
    OrderIds:any;
    DealerId:any;
} 